import { MailApi } from '../api/MailApi'
import { dataLayer } from '../mixins/gtc'

export const newsletter = {
	data () {
		return {
			newsletterFlash: null,
			newsletterState: null,
			newsletterLoading: false
		}
	},

	mixins: [
		dataLayer
	],

	methods: {
		$_newsletter_newsletterSubscribe (vars) {
			if (!vars) return

			this.newsletterLoading = true
			this.newsletterFlash = ''

			var params = {
				email: vars.email,
				name: vars.name
			}

			if (vars.list) params.list = vars.list
			if (vars.utm_campaign) params.utm_campaign = vars.utm_campaign
			if (vars.business_name) params.business_name = vars.business_name

			var mm = new MailApi()
			return mm.subscribe(params).then(response => {
				this.newsletterFlash = 'Grazie! Riceverai a breve una mail di conferma'
				this.newsletterState = 'success'

				this.newsletterLoading = false

				if (typeof this.afterSuccess === "function") this.afterSuccess()

				this.$_dataLayer_newsletterSubscribed(params.email)
			}).catch(response => {
				var error = response ? response.body.message : null
				this.newsletterFlash = 'L\'indirizzo email è già stato registrato'
				this.newsletterState = 'error'

				this.newsletterLoading = false
			})
		},

		$_newsletter_newsletterList (vars) {
			if (!vars) return

			this.newsletterLoading = true
			this.newsletterFlash = ''

			var params = {
				email: vars.email,
				name: vars.name
			}

			if (vars.list) params.list = vars.list
			if (vars.business_name) params.business_name = vars.business_name

			var mm = new MailApi()
			return mm.list(params).then(response => {
				this.newsletterFlash = 'Confermato!'
				this.newsletterState = 'success'

				this.newsletterLoading = false

				this.$_dataLayer_newsletterSubscribed(params.email)
			}).catch(response => {
				var error = response ? response.body.message : null
				this.newsletterFlash = 'L\'indirizzo email è già stato registrato'
				this.newsletterState = 'error'

				this.newsletterLoading = false
			})
		}
	}
}
